import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { InvalidDocument } from '../../../../../../../../models/inbox';
import { dateStringFromISO8601, timeStringFromISO8601 } from '../../../../../../../../utils';
import { AccountService } from '../../../../../../../../services/account/account.service';

@Component({
  selector: 'app-view-dismissed-invalid-document-modal',
  templateUrl: './view-dismissed-invalid-document-modal.component.html',
  styleUrls: ['./view-dismissed-invalid-document-modal.component.css']
})
export class ViewDismissedInvalidDocumentModalComponent implements OnInit {

  @Input() invalidDocument: InvalidDocument;

  // Create instance references to lookup functions and enums so they may be
  // called in the template.
  public dateStringFromISO8601 = dateStringFromISO8601;
  public timeStringFromISO8601 = timeStringFromISO8601;

  constructor(
    public accountService: AccountService,
    public activeModal: NgbActiveModal
  ) {}

  ngOnInit() {
    if (!this.accountService.getMyAccount().can_manage_members) {
      return;
    }
  }

}
